export const mockedSortFields = [
  { code: 'relevance', name: 'products.plp.sortOption.relevance', selected: true },
  { code: 'price-asc', name: 'products.plp.sortOption.priceLowToHigh', selected: false },
  { code: 'price-desc', name: 'products.plp.sortOption.priceHighToLow', selected: false },
  { code: 'newness', name: 'products.plp.sortOption.newArrivals', selected: false },
  { code: 'averageCustomerReview', name: 'products.plp.sortOption.customerRating', selected: false },
  { code: 'bestSellerRanking-asc', name: 'products.plp.sortOption.bestSellers', selected: false },
];

export const CLEARANCE_STATUS_BY_CODE = {
  N: 'Full Price',
  S: 'Markdown',
  O: 'Outlet',
  C: 'Clearance',
  J: 'Jobber',
};
